import axios from 'axios';
import { useCallback, useMemo, useState } from 'react';
import Form, { Validations } from '../../../../../components/Form';
import { ControlItem } from '../../../types';

import ServicePaths from '../../../../../bridge/utils/ServicePaths';

const RemoveBotForm = () => {
  const [botId, setBotId] = useState<string | undefined>();
  const [errors, setErrors] = useState<Record<string, Validations>>({});
  const [formMessage, setFormMessage] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const checkValidation = useCallback(() => {
    /** userId can not be empty */
    /** clusterId can not be empty */
    /** botId can not be empty */

    setErrors({});

    if (typeof botId === 'undefined') {
      setErrors((prev) => ({
        ...prev,
        botId: Validations.Required,
      }));
    }

    return true;
  }, [botId]);

  const handleRemoveBotSubmit = useCallback(async () => {
    setIsLoading(true);
    const canContinue = checkValidation();

    if (!canContinue) {
      setIsLoading(false);
      return;
    }

    const { data } = await axios({
      method: 'POST',
      url: ServicePaths.CONTROL.RemoveBot,
      params: {
        botId,
      },
    });

    setIsLoading(false);
    setFormMessage(data);
  }, [botId, checkValidation]);

  const config = useMemo(() => {
    return {
      title: ControlItem.RemoveBot,
      formMessage,
      fields: [
        {
          label: 'Bot Id',
          value: botId,
          handleValueChange: setBotId,
          error: errors.botId,
        },
      ],
      handleSubmit: handleRemoveBotSubmit,
      isLoading,
    };
  }, [botId, errors.botId, formMessage, handleRemoveBotSubmit, isLoading]);

  return <Form config={config} />;
};

export default RemoveBotForm;
